<template>
    <div class="main mt15">
        <div class="banner" @click="toBuy">
            <img src="../../../images/allRisksTab.jpg" alt="" ref="info">
            <div class="banner-container">
            </div>
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="产品特色" name="info"></TabPane>
                    <TabPane label="保障方案" name="case"></TabPane>
                    <TabPane label="常见问题" name="question"></TabPane>
                    <TabPane label="理赔流程" name="claim"></TabPane>
                </Tabs>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">产品特色</div>
            <div class="detail-main">
                <div style="color: red;">咨询电话：187 6642 6120</div>
                <div class="detail-main-text" ref="case">
                    建筑工程一切险是以建筑工程中的材料、装饰物料、设备等为保险标的的保险。有物损和三者损失组成。<br />物质损失保障的是在列明的工地范围内，因本保险合同责任免除以外的自然灾害或意外事故造成的损失。<br />三者损失保障的是因发生与本保险合同所承保工程直接相关的意外事故引起工地内及邻近区域的第三者人身伤亡、疾病或财产损失,依法应由被保险人承担的经济赔偿的责任。
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">保障方案</div>
            <div class="detail-main">
                <div class="center">
                    <table class="productDetail-table">
                        <thead>
                            <tr>
                                <th>项目</th>
                                <th>内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hoverTr">
                                <td>投保人</td>
                                <td>甲方或施工总承包</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>被保险人</td>
                                <td>甲方及施工总承包</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>项目信息</td>
                                <td>项目名称：按照合同中的项目名称为准<br />工程造价：按照合同中的合同造价为准
                                </td>
                            </tr>
                            <tr class="hoverTr">
                                <td>主险险种</td>
                                <td>建筑工程一切险及第三方责任险</td>
                            </tr>
                            <tr class="hoverTr">
                                <td rowspan="2">保额</td>
                                <td>物质保额：依据具体工程造价</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>第三者责任限额：累计限额 1000 万，每次事故赔偿限额 500 万，每人每次赔偿限额 100 万。</td>
                            </tr>
                            <tr class="hoverTr" ref="question">
                                <td>保险期限</td>
                                <td>保单生效日至工程竣工日</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保险费率</td>
                                <td>提供施工合同及工程量清单后获取报价</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">常见问题</div>
            <div class="detail-main">
                <div class="detail-main-text">
                    <p><b>1、投保人、被保险人是谁？</b></p>
                    <p>
                        答：投保人：：一般为业主或总承包单位<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;被保险人：通常是企业，可以同投保人
                    </p>
                    <p ref="claim"><b>2、如何投保？</b></p>
                    <p>答：提供营业执照、施工合同、工程量清单后获取精准保险方案，并由服务人员协助完成投保。</p>
                    <p><b>3、为什么选择我们投保？</b></p>
                    <p >答：我们由专业保险团队提供全流程服务，包括保险报价、协助投保操作、保单管理、保险理赔托管等综合保险服务，持续满足用户各类服务需求，让用户省心安心。</p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">理赔流程</div>
            <Steps class="mt30 step-con">
                <Step 
                    title="拨打报案电话" 
                    status="process"
                    content="请立即拨打报案电话18766426120进行报案，详细说明出险情况。被保险人应在48小时内及时报案。"
                ></Step>
                <Step 
                    title="提交索赔材料" 
                    status="process"
                    content="报案后我们会告知您所需的材料，请按照要求待治疗结束后提供资料。"
                ></Step>
                <Step 
                    title="领取赔款" 
                    status="process"
                    content="资料收到后，保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"
                ></Step>
            </Steps>
        </div>
        
        <div class="detail allDet detail-main-text">
             <p>
                <b>请添加以下微信进行询价</b>
             </p>
            <img src="../../../images/code.png"  style="width: 20%;margin-top: 15px;" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                renewId: this.$route.query.renewId || '' //续保，上一保单id
            }
        },
        mounted () {
            this.$nextTick(() => {
                window.addEventListener("scroll", this.handleScroll);
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 立即购买
            toBuy () {
                let url = '/haierProduct.html#/customized-employer-liability/fillin';
                if (this.renewId) url += `/${this.renewId}?renew=1&productCode=QYTTGZZRXPCNEW`
                else url += `?productCode=QYTTGZZRXPCNEW`
                location.href = url
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"
                })
            },
            // 定位到伤残费率表位置
            toSC () {
                this.$refs['SC'].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/productList/allRisks.vue